import Chip from "@mui/material/Chip";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { DemandAdjustment } from "../../types/demand-factor.type";
import { formatDateTimeBkk } from "../../utils/date";
import { STRIPE_BACKGROUND } from "../Product/shared/constants";
import {
  STATUS_COLOR,
  STATUS_LABEL,
  TYPE_DISABLED_LABEL,
  TYPE_LABEL,
  UNNAMED_ROW,
  formatDateRange,
  formatMultiplier,
} from "./constants";
import TargetChips from "./TargetChips";
import { TargetNames } from "./targetSummary";

interface DemandFactorRowProps {
  row: DemandAdjustment;
  striped: boolean;
  names: TargetNames;
  onEdit: (row: DemandAdjustment) => void;
  onDelete: (row: DemandAdjustment) => void;
}

export default function DemandFactorRow({
  row,
  striped,
  names,
  onEdit,
  onDelete,
}: DemandFactorRowProps) {
  const handleEdit = () => onEdit(row);
  const handleDelete = () => onDelete(row);

  return (
    <TableRow sx={{ bgcolor: striped ? STRIPE_BACKGROUND : "background.paper" }}>
      <TableCell>
        <Typography variant="body2" fontWeight={600}>
          {row.name ?? UNNAMED_ROW}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">{TYPE_LABEL[row.type]}</Typography>
        {!row.type_enabled && (
          <Stack
            direction="row"
            alignItems="center"
            gap={0.5}
            sx={{ color: "warning.main", typography: "caption" }}
          >
            <WarningAmberIcon fontSize="inherit" />
            {TYPE_DISABLED_LABEL}
          </Stack>
        )}
      </TableCell>
      <TableCell sx={{ whiteSpace: "nowrap" }}>
        {formatDateRange(row.valid_from, row.valid_to)}
      </TableCell>
      <TableCell align="right">
        <Typography variant="body2" fontWeight={600}>
          {formatMultiplier(row.multiplier)}
        </Typography>
      </TableCell>
      <TableCell>
        <TargetChips targets={row} names={names} />
      </TableCell>
      <TableCell align="center">
        <Chip size="small" label={STATUS_LABEL[row.status]} color={STATUS_COLOR[row.status]} />
      </TableCell>
      <TableCell>
        <Typography variant="body2">{row.updated_by ?? "-"}</Typography>
        <Typography variant="caption" color="text.secondary">
          {formatDateTimeBkk(row.updated_at)}
        </Typography>
      </TableCell>
      <TableCell>
        <Stack direction="row" gap={0.5}>
          <Tooltip title="แก้ไข">
            <IconButton size="small" color="primary" onClick={handleEdit}>
              <EditOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="ลบ">
            <IconButton size="small" color="error" onClick={handleDelete}>
              <DeleteOutlineOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Stack>
      </TableCell>
    </TableRow>
  );
}
